var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecruitment4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31758",
    "data-name": "\\uC0AC\\uAC01\\uD615 31758",
    width: 84,
    height: 80,
    transform: "translate(1771 4551)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31757",
    "data-name": "\\uC0AC\\uAC01\\uD615 31757",
    width: 74.321,
    height: 77.129,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_675",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 675",
    transform: "translate(-1771 -4551)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1231",
    "data-name": "\\uADF8\\uB8F9 1231",
    transform: "translate(1775.84 4552.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1230",
    "data-name": "\\uADF8\\uB8F9 1230",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31755",
    "data-name": "\\uC0AC\\uAC01\\uD615 31755",
    width: 38.632,
    height: 24.003,
    rx: 5.132,
    transform: "translate(34.313 51.751)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_31756",
    "data-name": "\\uC0AC\\uAC01\\uD615 31756",
    d: "M1.376,0H4.9A1.376,1.376,0,0,1,6.271,1.376V4.368A1.375,1.375,0,0,1,4.9,5.743H1.376A1.376,1.376,0,0,1,0,4.367V1.376A1.376,1.376,0,0,1,1.376,0Z",
    transform: "translate(50.432 60.513)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_218",
    "data-name": "\\uC120 218",
    x1: 16.058,
    y1: 4.638,
    transform: "translate(34.374 58.333)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_219",
    "data-name": "\\uC120 219",
    y1: 5.052,
    x2: 16.058,
    transform: "translate(56.87 58.333)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_220",
    "data-name": "\\uC120 220",
    x2: 8.887,
    transform: "translate(15.486 43.054)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_801",
    "data-name": "\\uD328\\uC2A4 801",
    d: "M38.424,35.378H18.31a9.8,9.8,0,0,1,9.8-9.8h.516A9.8,9.8,0,0,1,38.424,35.378Z",
    transform: "translate(-1.529 -2.137)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_579",
    "data-name": "\\uD0C0\\uC6D0 579",
    cx: 4.126,
    cy: 4.126,
    r: 4.126,
    transform: "translate(22.454 11.981)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_802",
    "data-name": "\\uD328\\uC2A4 802",
    d: "M12.413,46.852a1.375,1.375,0,1,1-1.375-1.375,1.375,1.375,0,0,1,1.375,1.375",
    transform: "translate(-0.807 -3.799)",
    fill: "#fefeff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_221",
    "data-name": "\\uC120 221",
    x2: 8.887,
    transform: "translate(15.486 51.45)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_803",
    "data-name": "\\uD328\\uC2A4 803",
    d: "M12.413,56.014a1.375,1.375,0,1,1-1.375-1.375,1.375,1.375,0,0,1,1.375,1.375",
    transform: "translate(-0.807 -4.564)",
    fill: "#fefeff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_222",
    "data-name": "\\uC120 222",
    x2: 8.887,
    transform: "translate(15.486 59.846)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_804",
    "data-name": "\\uD328\\uC2A4 804",
    d: "M12.413,65.176A1.375,1.375,0,1,1,11.039,63.8a1.375,1.375,0,0,1,1.375,1.375",
    transform: "translate(-0.807 -5.329)",
    fill: "#fefeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_805",
    "data-name": "\\uD328\\uC2A4 805",
    d: "M47.424,52.59V50.856a3.329,3.329,0,0,1,3.33-3.33H64.428a3.329,3.329,0,0,1,3.329,3.33V52.59",
    transform: "translate(-3.961 -3.97)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_806",
    "data-name": "\\uD328\\uC2A4 806",
    d: "M50.354,10.386,43.515,2.749,41.054,0H6.6A6.562,6.562,0,0,0,0,6.5V64.866a6.562,6.562,0,0,0,6.6,6.5H28.761a1.375,1.375,0,1,0,0-2.749H6.6a3.809,3.809,0,0,1-3.855-3.754V6.5A3.809,3.809,0,0,1,6.6,2.749H37.609v10.71a2.964,2.964,0,0,0,2.96,2.96h9.784V37.242a1.375,1.375,0,1,0,2.749,0V13.457ZM40.57,13.67a.211.211,0,0,1-.211-.211V3.346L49.6,13.67Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecruitment4);
export default __webpack_public_path__ + "static/media/icon_recruitment_4.e62546c6bc38392fba37f6509614dca0.svg";
export { ForwardRef as ReactComponent };